import type {FC} from 'react';
import {useGetColumnCarouselList} from '../../../../../../core/repositories/columnRepository';
import {cn} from '../../../../../../lib/classname';
import {Card, CardSkeleton} from '../../Card';
import {Carousel} from '../../Carousel';

type Props = {
  className?: string;
};
export const TopCarousel: FC<Props> = ({className}) => {
  const {data, isLoading} = useGetColumnCarouselList({});
  const posts = data?.ok ? data.value.carousel : [];
  return (
    <div className={cn('w-full bg-white py-16', className)}>
      <Carousel className="max-w-[1200px] ml-16 pc:mx-auto">
        <div
          className={cn('flex flex-nowrap gap-16 mr-16', 'pc:mx-0 pc:gap-24')}
        >
          {isLoading
            ? Array.from({length: 5}).map((_, index) => (
                <CardSkeleton
                  // biome-ignore lint/suspicious/noArrayIndexKey: placeholder
                  key={index}
                  className="w-[80vw] pc:w-[calc(((1200px-24px*2)/3)-30px)]"
                  imageHeight={148}
                />
              ))
            : posts.map((post) => (
                <Card
                  key={post.id}
                  id={post.id}
                  title={post.title}
                  clipCount={post.favoriteCount}
                  isClipped={post.favorited}
                  thumbnail={post.cardImageURL ?? post.imageURL}
                  className="w-[80vw] pc:w-[calc(((1200px-24px*2)/3)-30px)]"
                  sponsoredOption={{enabled: false}}
                  tagNames={post.tags}
                />
              ))}
        </div>
      </Carousel>
    </div>
  );
};
